import * as React from 'react';
import { Button } from '@cian/ui-kit';

import logo from './assets/logo.svg';
import { BanksList } from './components/BanksList';
import * as styles from './Mortgage.css';
import { Section } from '../Section';

interface IMortgageProps {
  banksLogo: string[];
  banksMoreCount: number;
  buttonText: string;
  description: string;
  url: string;
}

export const Mortgage: React.FC<IMortgageProps> = ({ banksMoreCount, banksLogo, buttonText, description, url }) => {
  return (
    <Section>
      <a className={styles['container']} href={url} target="_blank" rel="noopener noreferrer">
        <div className={styles['inner']}>
          <div className={styles['description']}>
            <img className={styles['mortgage-logo']} src={logo} alt="ЦИАН.Ипотека" />
            <h3 className={styles['description-text']}>{description}</h3>
            <div className={styles['button']}>
              <Button size="M">{buttonText}</Button>
            </div>
          </div>
          <div className={styles['banks-list']}>
            <BanksList logos={banksLogo} moreCount={banksMoreCount} />
          </div>
        </div>
      </a>
    </Section>
  );
};
